// extracted by mini-css-extract-plugin
export default {"container":"ImageActivationFields_container__RLp8i"};